import { Link, NavLink, Outlet } from "react-router-dom";
import { ArrowLeftRight, Building2, ExternalLink, LogOut } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { LOGOUT } from "@/constants/testIds/auth";
import "./admin.css";

const navClass = ({ isActive }) =>
  `admin-btn admin-btn-ghost !py-2 !px-3 text-sm ${isActive ? "!border-[#0052ff]/60 !bg-[#0052ff]/15 !text-white" : ""}`;

export default function AdminLayout() {
  const { user, logout } = useAdminAuth();

  return (
    <div className="admin-shell admin-grid-bg min-h-screen">
      <header className="admin-nav">
        <div className="admin-brand">
          <div className="admin-brand-mark">B</div>
          <div>
            <p className="text-sm font-medium tracking-[-0.02em] text-white">BrokerSignals admin</p>
            <p className="admin-mono text-[11px] text-[#64748b]">Signed in as {user?.username}</p>
          </div>
        </div>

        <nav className="flex flex-wrap items-center gap-2">
          <NavLink to="/admin/brokers" className={navClass} data-testid="admin-nav-brokers">
            <Building2 size={15} /> Brokers
          </NavLink>
          <NavLink to="/admin/swaps" className={navClass} data-testid="admin-nav-swaps">
            <ArrowLeftRight size={15} /> Swaps
          </NavLink>
          <Link to="/" className="admin-btn admin-btn-ghost !py-2 !px-3 text-sm" target="_blank" rel="noreferrer">
            <ExternalLink size={15} /> Site
          </Link>
          <button type="button" onClick={logout} className="admin-btn admin-btn-ghost !py-2 !px-3 text-sm" data-testid={LOGOUT.button}>
            <LogOut size={15} /> Sign out
          </button>
        </nav>
      </header>

      <main className="mx-auto w-full max-w-6xl px-4 py-8 sm:px-6">
        <Outlet />
      </main>
    </div>
  );
}
